import {types, getSnapshot, applySnapshot, ModelActions} from 'mobx-state-tree';

interface IActions extends ModelActions {
  resetModel: () => void;
}

const ResetModel = types.model('ResetModel', {}).actions<IActions>((self) => {
  let initialState = {};

  return {
    afterCreate() {
      /** save a snapshot after the first initialising */
      initialState = getSnapshot(self);
    },
    resetModel() {
      /** back the initial state */
      applySnapshot(self, initialState);
    }
  };
});

export {ResetModel};
